<div class="cms-page">
    <div class="cms-page-accent cms-page-accent-one" aria-hidden="true"></div>
    <div class="cms-page-accent cms-page-accent-two" aria-hidden="true"></div>
    <div class="container">
        <section class="cms-loading" *ngIf="mode === 'loading'" aria-live="polite">
            <span class="cms-spinner" aria-hidden="true"></span>
            <p>Cargando administración…</p>
        </section>

        <section class="cms-login" *ngIf="mode === 'login'">
            <div class="cms-login-card">
                <div class="cms-login-brand" aria-hidden="true">
                    <img src="assets/img/logo.png" alt="">
                </div>
                <h1 class="cms-login-title">Administración</h1>
                <p class="cms-login-subtitle">Ingresa para gestionar el contenido del sitio.</p>
                <mat-form-field appearance="outline" class="cms-field">
                    <mat-label>Correo</mat-label>
                    <input matInput type="email" [(ngModel)]="email" (keyup.enter)="login()" autocomplete="username">
                </mat-form-field>
                <mat-form-field appearance="outline" class="cms-field">
                    <mat-label>Contraseña</mat-label>
                    <input matInput type="password" [(ngModel)]="password" (keyup.enter)="login()" autocomplete="current-password">
                </mat-form-field>
                <p class="cms-login-error" *ngIf="loginError">{{ loginError }}</p>
                <button mat-raised-button color="primary" class="cms-login-button" (click)="login()" [disabled]="loggingIn || !email || !password">
                    <i class="fas fa-arrow-right" aria-hidden="true"></i>
                    {{ loggingIn ? 'Ingresando…' : 'Ingresar al panel' }}
                </button>
            </div>
        </section>

        <section class="cms-admin" *ngIf="mode === 'ready' && activeCollection">
            <div class="cms-toolbar">
                <div class="cms-heading">
                    <h1 class="cms-title">Panel de <span>administración</span></h1>
                    <p>Gestiona el contenido que se muestra en el sitio web.</p>
                </div>
                <div class="cms-actions">
                    <button type="button" class="cms-refresh-button" (click)="loadRows()" [disabled]="loadingRows" aria-label="Refrescar contenido" title="Refrescar">
                        <i class="fas fa-rotate-right" [class.cms-refreshing]="loadingRows" aria-hidden="true"></i>
                    </button>
                    <button mat-raised-button color="primary" class="cms-button cms-button-primary" (click)="newRow()">
                        <i class="fas fa-plus" aria-hidden="true"></i> Nuevo
                    </button>
                    <button mat-stroked-button class="cms-button cms-button-logout" (click)="logout()">
                        <i class="fas fa-arrow-right-from-bracket" aria-hidden="true"></i> Cerrar sesión
                    </button>
                </div>
            </div>

            <div class="cms-tabs" aria-label="Secciones de contenido">
                <button
                    *ngFor="let collection of collections; let index = index"
                    type="button"
                    class="cms-tab"
                    [class.active]="index === activeIndex"
                    (click)="switchCollection(index)"
                >{{ collection.label }}</button>
            </div>

            <mat-form-field appearance="outline" class="cms-search">
                <i matPrefix class="fas fa-magnifying-glass" aria-hidden="true"></i>
                <input matInput (keyup)="applyFilter($event)" [placeholder]="'Buscar en ' + activeCollection.label" aria-label="Buscar contenido">
            </mat-form-field>

            <div class="cms-table-card">
                <div class="cms-table-heading">
                    <div>
                        <h2>{{ activeCollection.label }}</h2>
                    </div>
                    <small>{{ rows.length }} {{ rows.length === 1 ? 'registro' : 'registros' }}</small>
                </div>
                <div class="cms-progress" *ngIf="loadingRows" aria-label="Actualizando contenido"></div>
                <div class="cms-table-wrap">
                <table mat-table [dataSource]="dataSource" matSort class="cms-table">
                    <ng-container *ngFor="let field of activeCollection.fields">
                        <ng-container *ngIf="!field.hideInTable">
                            <ng-container matColumnDef="{{ field.name }}">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ field.label }}</th>
                                <td mat-cell *matCellDef="let row">
                                    <img
                                        *ngIf="field.type === 'image' && preview(fileId(row[field.name])) | async as url"
                                        [src]="url"
                                        alt=""
                                        class="cms-thumb"
                                    >
                                    <span *ngIf="field.type !== 'image'">{{ cellText(row, field) }}</span>
                                </td>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="columnNames"></tr>
                    <tr mat-row *matRowDef="let row; columns: columnNames" class="cms-row" (click)="editRow(row)"></tr>
                </table>
                <mat-paginator
                    [pageSizeOptions]="[10, 25, 50, 100]"
                    [pageSize]="10"
                    showFirstLastButtons
                    aria-label="Paginación de la tabla"
                ></mat-paginator>
                </div>
            </div>
        </section>
    </div>
</div>
